import 'slick-carousel';
import 'slick-lightbox';

import AOS from 'aos';
AOS.init({
    disable: 'mobile',
    once: true,
    duration: 500,
    anchorPlacement: 'top-bottom',
});

// global
import './global/global.js';
import './global/modal.js';
import './global/header.js';
import './global/contact-form.js';

import './web-components/accordion-item.js';

/**
 * Template Parts
 */
import './template-parts/accordion.js';
import './template-parts/single-post.js';
import './template-parts/slider.js';
import './template-parts/dialog.js';
import './template-parts/tabs.js';
import './template-parts/inputs.js';

/**
 * Blocks
 */

import "../../blocks/accreditations/accreditations.js";
import "../../blocks/blog-listing/blog-listing.js";
import "../../blocks/features/features.js";
import "../../blocks/gallery/gallery.js";
import "../../blocks/icons/icons.js";
import "../../blocks/image-and-content-slider/image-and-content-slider.js";
import "../../blocks/staggered-content/staggered-content.js";
import "../../blocks/homepage-banner/homepage-banner.js";
import "../../blocks/slider-popup-info/slider-popup-info.js";
